var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-text-filter",style:(_vm.styleColor)},[_c('a-input',{style:(_vm.styleInput),attrs:{"placeholder":_vm.placeholder},on:{"input":_vm.textInput},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"textValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }